import React from "react"
import ReactDOM from "react-dom/client"
import { Provider as ReduxProvider } from "react-redux"
import { ChakraProvider } from "@chakra-ui/react"
import {
  ClayLightTheme,
  ClayProvider,
  SnackbarProvider,
} from "@mezo-org/mezo-clay"
import { createRouter, RouterProvider } from "@tanstack/react-router"

import { MezoPosthogProvider, WalletInContextProvider } from "#/providers"
import { COMMIT_HASH, MEZO_NETWORK } from "#/shared/constants"

import { NotFoundRoute } from "./routes/__root"
import store from "./redux-state"
import { routeTree } from "./routeTree.gen"
import theme from "./theme"

import "@rainbow-me/rainbowkit/styles.css"
import "#/assets/fonts/riforma/font-face.css"
import "#/assets/fonts/gtalpina/font-face.css"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

// eslint-disable-next-line no-console
console.log("🔮 environment:", MEZO_NETWORK, `\n⛓️ commit: ${COMMIT_HASH}`)

const router = createRouter({
  routeTree,
  defaultNotFoundComponent: NotFoundRoute,
  scrollRestoration: true,
})

const root = document.getElementById("root")!

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <MezoPosthogProvider>
      <ReduxProvider store={store}>
        <WalletInContextProvider>
          <ClayProvider theme={ClayLightTheme}>
            <SnackbarProvider placement="topRight">
              <ChakraProvider theme={theme}>
                <RouterProvider router={router} />
              </ChakraProvider>
            </SnackbarProvider>
          </ClayProvider>
        </WalletInContextProvider>
      </ReduxProvider>
    </MezoPosthogProvider>
  </React.StrictMode>,
)
